import React from "react";
import { useTranslation } from "react-i18next";
import { ButtonBase, InputSelect } from "../../../../common/components/form";
import { BusinessGoalsECommerce } from "../../../lib/business-goals.js";
import { CountryCode2Locale } from "../../../lib/localisations.js";
import Dashed from "../../Dashed";
import BackNext from "../BackNext.jsx";

const DefaultSEOLocation = "US";

export default function WStepECommerceBusinessGoal(props) {
    const { t } = useTranslation();

    const {
        set,
        next,
        variables,
        variables: { SEOLocation, BusinessGoal, Localisation },

        GTC,
    } = props;

    // First (init)
    React.useEffect(() => {
        if (!SEOLocation) {
            const locale = Localisation || CountryCode2Locale[DefaultSEOLocation].split("-")[0];

            set({
                ...variables,
                SEOLocation: DefaultSEOLocation,
                Localisation: locale,
            });
        }
    }, [variables]);

    function onSEOLocationSelect(value) {
        const locale = CountryCode2Locale[value].split("-")[0];

        set({
            ...variables,
            SEOLocation: value,
            Localisation: locale,
        });
    }

    function onBusinessGoalClick(id) {
        next(null, { ...variables, BusinessGoal: id });
    }

    return (
        <div className="wizard-part-inner">
            <div
                className="grid-gap-40 align-items-center"
                style={{ gridTemplateRows: "max-content max-content max-content 80px" }}
            >
                <p className="padding-top-40" style={{ whiteSpace: "break-spaces" }}>
                    {t("BusinessECommerceHeader")}
                </p>

                <div>
                    <InputSelect
                        placeholder={t("Select the country of sale")}
                        options={GTC.map(({ name, country_code }) => ({
                            value: country_code,
                            text: `(${country_code}) ${name}`,
                        }))}
                        onSelect={onSEOLocationSelect}
                        selected={SEOLocation}
                        filterField
                        fullWidth
                    />
                </div>

                <div className="wizard-business-goal-list">
                    {/* from WStepBusinessGoals */}
                    {(props.goals || BusinessGoalsECommerce).map(({ name_t, desc_t, value }) => {
                        const dProps = { className: "wizard-business-goal-item" };

                        BusinessGoal === value && (dProps.solid = true);

                        return (
                            <Dashed key={value} {...dProps}>
                                <h2>{t(name_t)}</h2>
                                <p>{t(desc_t)}</p>

                                <ButtonBase solid onClick={() => onBusinessGoalClick(value)} disabled={!SEOLocation}>
                                    {t("Select")}
                                </ButtonBase>
                            </Dashed>
                        );
                    })}
                </div>
            </div>

            <BackNext {...props} next={null} generate={null} />
        </div>
    );
}
